import {useCallback, useEffect, useRef, useState} from 'react';
import useApi from './useApi.hook';
import useOnPageReturn from './useOnPageReturn.hook';
import {downloadsSummaryUrl} from '../helpers/constants';
import {DOWNLOADS_CHANGED_EVENT} from '../helpers/downloadsEvents';

const POLL_MS = 10000;
const IDLE_POLL_MS = 15000;

// Polls often while something is being generated and rarely otherwise: a task
// queued through MCP raises no browser event. Also refetches on a
// `downloads:changed` event and when the user comes back to the tab.
export default function useDownloadsSummary() {
	const api = useApi();
	const [summary, setSummary] = useState({pending: 0, ready_unseen: 0});
	const timer = useRef(null);

	const fetchSummary = useCallback(async () => {
		clearTimeout(timer.current);
		try {
			const {data} = await api.get(downloadsSummaryUrl);
			setSummary(data);
			if (!document.hidden) {
				timer.current = setTimeout(fetchSummary, data.pending > 0 ? POLL_MS : IDLE_POLL_MS);
			}
		} catch {
			// The badge is a hint; a failed poll must not bother the user.
		}
	}, [api]);

	useEffect(() => {
		fetchSummary();
		window.addEventListener(DOWNLOADS_CHANGED_EVENT, fetchSummary);
		return () => {
			clearTimeout(timer.current);
			window.removeEventListener(DOWNLOADS_CHANGED_EVENT, fetchSummary);
		};
	}, [fetchSummary]);

	useOnPageReturn(fetchSummary);

	return summary;
}
